module.exports = __webpack_public_path__ + "static/media/043-Beaver & Bulldog.8efcafb3.jpg";